import DisplayCards from "../dashboard/displaycards";
import Image from "../../Image";

import { useSelector } from "react-redux";
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Paper,
} from "@material-ui/core";

const ClientTable = () => {
  const { earnings, totalLoanAmount, clientList } = useSelector(
    (state) => state.lamfReducer
  );
  return (
    <div className="container-margin">
      <div className="investor-title">Earnings</div>
      <div className="flex">
        <DisplayCards
          image="/images/aum_dashboard.svg"
          alt="Total Earnings"
          name="Total Earnings"
          values={"₹" + earnings}
        />
        <DisplayCards
          image="/images/schemes_dashboard.svg"
          alt="Total Loan Amount"
          name="Total Loan Amount Disbursed"
          values={"₹" + totalLoanAmount}
        />
        <DisplayCards
          image="/images/investors_dashboard.svg"
          alt="Total Clients"
          name="Total Clients"
          values={clientList.length}
        />
      </div>
      <div className="d-flex flex-row justify-content-left mt-5">
        <Paper className="lamf-table">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className="table-cell">Investor Name</TableCell>
                <TableCell className="table-cell">Loan Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clientList.map((_client, index) => (
                <TableRow key={index}>
                  <TableCell className="table-cell">
                    <Image
                      src="/images/user.png"
                      alt="user"
                      className="user-icon"
                    />
                    <span
                      className="investor-name"
                      style={{ fontFamily: "OpenSans-SemiBold" }}
                    >
                      {_client.name}
                    </span>
                  </TableCell>
                  <TableCell className="table-cell">
                    <Image
                      src={"/images/new_transaction.svg"}
                      alt="loan-amount"
                      className="phone-icon"
                    />
                    {_client.creditLineAmount}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    </div>
  );
};
export default ClientTable;
